import LandingPageJumbotron from '@/app/components/LandingPage/LandingPageJumbotron';

const ScienceAndResearchFooter = (): JSX.Element => {
  return (
    <section
      className="bg-neutral-800 py-20"
      data-cy="science-and-research-footer"
    >
      <LandingPageJumbotron
        contentWidth="tight"
        title="science_and_research_footer_eyebrow"
        description="science_and_research_footer_title"
        macronIcon
        inverted
      />
    </section>
  );
};

export default ScienceAndResearchFooter;
